module.exports = __webpack_public_path__ + "assets/img/introduceTwo.ce1ca8da.png";